import React, { useEffect } from "react";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { PayoutsTable } from "../PayoutsTable";

export default function Payouts({ payouts, bankAccount, handleView }) {
  return (
    <>
      <Card body>
        <Stack
          direction="horizontal"
          gap={3}
          className="card-body-heading card-body-heading--sm payouts"
        >
          <Card.Title as="h5">Payouts</Card.Title>
        </Stack>
        <Stack gap={4}>
          <PayoutsTable
            payouts={payouts}
            bankAccount={bankAccount}
            handleView={handleView}
          />
          {/* <Button
            variant="outline-light"
            size="lg"
            onClick={handleView}
            className="align-self-center"
          >
            View all payouts
          </Button> */}
        </Stack>
      </Card>
    </>
  );
}
